import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { BuildingPermit } from 'types/Documents';

export const useBuildingPermit = (id: string | null) =>
  useDocumentDetails<Document<BuildingPermit> | null>(id);
